import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { WarningStatusIcon } from 'components/SVG';
import { SparkButton } from 'sharedComponents/UI';
import { useSparkBuilderStore } from 'stores';
import { useReactFlowStore } from 'components/CreateSpark/SparkBuilderCanvas/hooks';

type BoardNodeConnectionErrorProps = {
  isSparkOutputPreview: boolean;
  sparkStepID: string | null;
};

export default function BoardNodeConnectionError({
  isSparkOutputPreview,
  sparkStepID,
}: BoardNodeConnectionErrorProps) {
  const setSelectedStep = useSparkBuilderStore(
    (store) => store.builderSideBarActions.setSelectedStep
  );
  const { addSelectedNodes } = useReactFlowStore();
  const handleClick = () => {
    if (!sparkStepID) {
      return;
    }
    addSelectedNodes([sparkStepID]);
    setSelectedStep({ type: 'sparkStep', id: sparkStepID });
  };

  return (
    <Grid
      container
      width='100%'
      justifyContent='center'
      alignItems='center'
      paddingY={1}
      bgcolor='white'
      borderRadius={'10px'}
    >
      <Box display='flex' flexDirection='column' alignItems='center' gap={1.5}>
        <WarningStatusIcon />
        <Typography margin='0 !important'>Output Error</Typography>
        {isSparkOutputPreview && (
          <>
            <Typography
              variant='body2'
              color='text.secondary'
              margin='0 !important'
            >
              The linked step does not have valid output.
            </Typography>
            <SparkButton variant='contained' onClick={handleClick}>
              Fix Step
            </SparkButton>
          </>
        )}
      </Box>
    </Grid>
  );
}
